import { VariantProps } from 'class-variance-authority';
import { StepperItem, type StepperItemProps } from './StepperItem';
import { stepper, stepperContent } from './base';

export interface StepperProps extends VariantProps<typeof stepper> {
  items: StepperItemProps[];
  ariaLabel?: string;
  currentStepIndex?: number;
}

export const Stepper = ({
  items,
  spacing,
  ariaLabel,
  currentStepIndex: controlledStepIndex,
}: StepperProps) => {
  const currentStepIndex =
    controlledStepIndex ??
    Math.min(
      Math.max(
        items.findIndex((item) => !item.checked && !item.subdued),
        0,
      ),
      items.length - 1,
    );

  return (
    <div className={stepper({ spacing })} aria-label={ariaLabel}>
      <div
        role="progressbar"
        aria-valuemin={1}
        aria-valuemax={items.length}
        aria-valuenow={currentStepIndex + 1}
        aria-label={`Step ${currentStepIndex + 1} of ${items.length}`}
        className={stepperContent({ spacing })}
      >
        {items.map((item, index) => (
          <div
            // eslint-disable-next-line react-x/no-array-index-key -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
            key={`step-${index}`}
            aria-current={index === currentStepIndex ? 'step' : undefined}
          >
            <StepperItem
              checked={item.checked}
              subdued={item.subdued}
              text={item.text}
              ariaLabel={item.ariaLabel}
              step={index + 1}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
